import axios from "axios";

/*
 * Performs the axios call for the singular search function
 */
async function singularSearch(metadataName, metadataValue, searchScope, pageNumber) {
  let url = `${process.env.VUE_APP_API_GATEWAY}getSingularSearch?key=${process.env.VUE_APP_API_KEY}&searchScope=${searchScope}&pageNumber=${pageNumber}`;

  if (metadataName) {
    url = `${url}&metadataName=${metadataName}`;
  }

  if (metadataValue) {
    url = `${url}&metadataValue=${encodeURIComponent(metadataValue)}`;
  }

  return axios.get(url);
}

/*
 * Performs the axios call for the advanced search function
 */
async function advancedSearch(query, pageNumber) {
  const url = `${process.env.VUE_APP_API_GATEWAY}getAdvancedSearch?key=${process.env.VUE_APP_API_KEY}&query=${encodeURIComponent(query)}&pageNumber=${pageNumber}`;

  return axios.get(url);
}

/*
 * Performs the axios call for the index search function
 */
async function indexSearch(searchScope, pageNumber) {
  const url = `${process.env.VUE_APP_API_GATEWAY}getIndexSearch?key=${process.env.VUE_APP_API_KEY}&searchScope=${searchScope}&pageNumber=${pageNumber}`;

  return axios.get(url);
}

/*
 * Performs the axios call for the document id search function
 */
async function documentIdSearch(documentId) {
  const url = `${process.env.VUE_APP_API_GATEWAY}getDocumentIdSearch?key=${process.env.VUE_APP_API_KEY}&document_id=${documentId}`;

  return axios.get(url);
}

/*
 * Performs the axios call for the file latest function
 */
async function fileLatest(documentId) {
  const url = `${process.env.VUE_APP_API_GATEWAY}getFileLatest?key=${process.env.VUE_APP_API_KEY}&document_id=${documentId}`;

  return axios.get(url);
}

/*
 * Performs the axios call for the download url function
 */
async function downloadUrl(fileUrl) {
  const url = `${process.env.VUE_APP_API_GATEWAY}getDownloadUrl?key=${process.env.VUE_APP_API_KEY}&file_url=${fileUrl}`;

  return axios.get(url);
}

/*
 * Performs the axios call for the delete file function
 */
async function deleteFile(documentId) {
  const url = `${process.env.VUE_APP_API_GATEWAY}deleteFile?key=${process.env.VUE_APP_API_KEY}&document_id=${documentId}`;

  return axios.get(url);
}

/*
 * Performs the axios call for the delete file version function
 */
async function deleteFileVersion(documentId, fileId) {
  const url = `${process.env.VUE_APP_API_GATEWAY}deleteFileVersion?key=${process.env.VUE_APP_API_KEY}&document_id=${documentId}&file_id=${fileId}`;

  return axios.get(url);
}

/*
 * Performs the axios call for the folder structure function
 */
async function folderStructure() {
  const url = `${process.env.VUE_APP_API_GATEWAY}getFolderStructure?key=${process.env.VUE_APP_API_KEY}`;

  return axios.get(url);
}

/*
 * Performs the axios call for the editFileVersionData function
 */
async function editFileVersionData(documentId, emphasizeFileId, hiddenFileId) {
  const url = `${process.env.VUE_APP_API_GATEWAY}editFileVersionData?document_id=${documentId}&emphasizeFileId=${emphasizeFileId}&hiddenFileId=${hiddenFileId}&key=${process.env.VUE_APP_API_KEY}`;

  const response = await axios.get(url);

  return response;
}

export default {
  singularSearch,
  advancedSearch,
  indexSearch,
  documentIdSearch,
  fileLatest,
  downloadUrl,
  deleteFile,
  deleteFileVersion,
  folderStructure,
  editFileVersionData
};
